import React from "react";
import { Link } from "react-router";
import axios from "axios";
import classNames from "classnames";
import Filter from "../../../components/Filter";
import ChapterProgress from "../../../components/ChapterProgress";

export default class competenceprofilesMeasurementMoments extends React.Component {
    constructor(props) {
        super(props);

        let defaultFilters = {};
        defaultFilters["is_active"] = "1";

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            competenceprofile: false,
            competenceprofileData: false,
            eventTemplates: false,
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0,
            activeFilters: defaultFilters
        };
    }

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0
        });
    };

    handleFilter = (name, value) => {
        let activeFilters = this.state.activeFilters;
        activeFilters[name] = value;

        this.setState({
            activeFilters,
            offset: 0
        });
        this.getResults(this.state.offset);
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.router.push("/competenceprofiles/");
    };

    handleSubmitPrevious = (e) => {
        e.preventDefault();
        this.props.router.push(`/competenceprofiles/edit/${this.props.params.itemID}/resume`);
    };

    getResults = (offset) => {
        this.cancelAxiosRequest();
        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        axios
            .get("/v1/competenceprofiles/" + this.props.params.itemID + "/eventtemplates/", {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                },
                cancelToken: this.cancelSource.token
            })
            .then((response) => {
                this.setState({
                    resultRows: response.data.results,
                    count: response.data.count,
                    limit: response.data.limit,
                    offset: response.data.offset
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    toggleItem = (e, itemID, itemName, currentStatus) => {
        let question = "Weet je zeker dat je dit standaard toetsmoment wilt activeren?";
        let description = `Dit standaard toetsmoment '${itemName}' is succesvol geactiveerd`;

        if (currentStatus) {
            // Current status is true, so we toggle to false
            question = "Weet je zeker dat je dit standaard toetsmoment wilt deactiveren?";
            description = `Dit standaard toetsmoment '${itemName}' is succesvol gedeactiveerd`;
        }

        if (confirm(question)) {
            axios
                .patch(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${itemID}/`, {
                    is_active: !currentStatus
                })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${response.data.uuid}`
                    });
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    deleteItem = (e, itemID, itemName) => {
        let question = "Weet je zeker dat je dit standaard toetsmoment wilt verwijderen?";
        let description = `Dit standaard toetsmoment '${itemName}' is succesvol verwijderd`;

        if (confirm(question)) {
            axios
                .delete(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${itemID}/`)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${response.data.uuid}`
                    });
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        axios
            .all([axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/"), axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/end_terms/")])
            .then(
                axios.spread((cp, cpData) => {
                    this.setState({
                        competenceprofile: cp.data,
                        competenceprofileData: cpData.data
                    });

                    this.getResults(0);
                })
            )
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let momentRows = [];
        if (!this.state.resultRows) {
            return (
                <div>
                    <div className="section-top">
                        <h1>Ophalen van alle details...</h1>
                    </div>
                </div>
            );
        } else if (this.state.resultRows.length === 0) {
            momentRows.push(
                <tr key="no-results">
                    <td colSpan="10">Er zijn nog geen standaard toetsmomenten aangemaakt voor dit competentieprofiel.</td>
                </tr>
            );
        } else {
            let totalCompetences = 0;
            let checkCompetences = [];
            this.state.competenceprofileData.forEach((cp) => {
                cp.competences.forEach((comp) => {
                    if (checkCompetences.find((c) => c.uuid == comp.uuid) == undefined) {
                        checkCompetences.push({
                            uuid: comp.uuid
                        });
                        totalCompetences++;
                    }
                });
            });

            this.state.resultRows.forEach((result) => {
                let classnames = classNames({ inactive: !result.is_active });
                let competences = 0;
                let competenceCount = [];
                let prerequisites = [];

                result.roles.forEach((role) => {
                    role.end_terms.forEach((et) => {
                        et.competences.forEach((comp) => {
                            competenceCount.push(comp.uuid);
                        });
                    });
                });

                competences = competenceCount.length;
                result.prerequisites.forEach((prereq) => {
                    this.state.resultRows.forEach((row) => {
                        if (row.uuid === prereq) {
                            prerequisites.push(row.name);
                        }
                    });
                });

                let activateItem = (
                    <i
                        className="fa fa-toggle-on"
                        title="Deactiveren"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.toggleItem(e, result.uuid, result.name, result.is_active);
                        }}
                    ></i>
                );
                if (!result.is_active) {
                    activateItem = (
                        <i
                            className="fa fa-toggle-off"
                            title="Activeren"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.toggleItem(e, result.uuid, result.name, result.is_active);
                            }}
                        ></i>
                    );
                }

                if (result.parent == null) {
                    let type = "Praktijk";
                    if (result.type === "knowledge") {
                        type = "Kennis";
                    }
                    if (result.type === "knowledge-exam") {
                        type = "Theorietoets";
                    }
                    if (result.type === "elearning") {
                        type = "E-learning";
                    }

                    let textPrerequisites = false;
                    if (prerequisites.length > 0) {
                        textPrerequisites = (
                            <span className="lighter">
                                <br />
                                Afhankelijk van {prerequisites.join(", ")}
                            </span>
                        );
                    }

                    momentRows.push(
                        <tr
                            className={classnames}
                            key={result.uuid}
                            onClick={() => {
                                this.props.router.push(`/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${result.uuid}`);
                            }}
                        >
                            <td>{result.order}.</td>
                            <td>
                                {result.name}
                                {textPrerequisites}
                            </td>
                            <td>
                                {type}{" "}
                                {result.type === "knowledge-exam" ? (
                                    <i
                                        className="fa fa-table"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.props.router.push(
                                                `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/knowledgeexams/${result.uuid}`
                                            );
                                        }}
                                    ></i>
                                ) : (
                                    ""
                                )}
                            </td>
                            <td>
                                {competences} / {totalCompetences} ({Math.round((competences / totalCompetences) * 1000) / 10}%)
                            </td>
                            <td>
                                {activateItem}
                                {result.roles_are_editable ? (
                                    <i
                                        className="fa fa-trash"
                                        title="Verwijderen"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.deleteItem(e, result.uuid, result.name);
                                        }}
                                    ></i>
                                ) : (
                                    ""
                                )}
                            </td>
                        </tr>
                    );

                    this.state.resultRows
                        .filter((res) => res.parent == result.uuid)
                        .forEach((res) => {
                            classnames = classNames("noborder", { inactive: !res.is_active });
                            let competenceCount = [];

                            res.roles.forEach((role) => {
                                role.end_terms.forEach((et) => {
                                    et.competences.forEach((comp) => {
                                        if (!competenceCount.find((c) => c === comp.uuid)) {
                                            competenceCount.push(comp.uuid);
                                        }
                                    });
                                });
                            });
                            competences = competenceCount.length;
                            prerequisites = [];
                            res.prerequisites.forEach((prereq) => {
                                this.state.resultRows.forEach((row) => {
                                    if (row.uuid === prereq) {
                                        prerequisites.push(row.name);
                                    }
                                });
                            });

                            activateItem = (
                                <i
                                    className="fa fa-toggle-on"
                                    title="Deactiveren"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.toggleItem(e, res.uuid, res.name, res.is_active);
                                    }}
                                ></i>
                            );
                            if (!res.is_active) {
                                activateItem = (
                                    <i
                                        className="fa fa-toggle-off"
                                        title="Activeren"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.toggleItem(e, res.uuid, res.name, res.is_active);
                                        }}
                                    ></i>
                                );
                            }

                            let subType = "Praktijk";
                            if (res.type === "knowledge") {
                                subType = "Kennis";
                            }
                            if (res.type === "knowledge-exam") {
                                subType = "Theorietoets";
                            }
                            if (res.type === "elearning") {
                                subType = "E-learning";
                            }

                            let textPrerequisites = false;
                            if (res.prerequisites.length > 0) {
                                textPrerequisites = (
                                    <span className="lighter">
                                        <br />
                                        Afhankelijk van {prerequisites.join(", ")}
                                    </span>
                                );
                            }

                            momentRows.push(
                                <tr
                                    className={classnames}
                                    key={res.uuid}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.props.router.push(`/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${res.uuid}`);
                                    }}
                                >
                                    <td>
                                        {result.order}.{res.order}.
                                    </td>
                                    <td>
                                        {res.name}
                                        {textPrerequisites}
                                    </td>
                                    <td>
                                        {subType}{" "}
                                        {res.type === "knowledge-exam" ? (
                                            <i
                                                className="fa fa-table"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.props.router.push(
                                                        `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/knowledgeexams/${res.uuid}`
                                                    );
                                                }}
                                            ></i>
                                        ) : (
                                            ""
                                        )}
                                    </td>
                                    <td>
                                        {competences} / {totalCompetences} ({Math.round((competences / totalCompetences) * 1000) / 10}%)
                                    </td>
                                    <td>
                                        {activateItem}
                                        {res.roles_are_editable ? (
                                            <i
                                                className="fa fa-trash"
                                                title="Verwijderen"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.deleteItem(e, res.uuid, res.name);
                                                }}
                                            ></i>
                                        ) : (
                                            ""
                                        )}
                                    </td>
                                </tr>
                            );
                        });
                }
            });
        }

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/competenceprofiles"}>Competentieprofielen</Link>
                    </div>
                    <h1>
                        <strong>{this.state.competenceprofile.name}</strong>
                    </h1>

                    <ChapterProgress
                        chapters={[
                            { title: "Algemene gegevens", link: "/competenceprofiles/edit/" + this.props.params.itemID },
                            { title: "Competenties", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/competences" },
                            { title: "Toetsingen", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements" },
                            { title: "Toetsbundels", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/bundles" },
                            { title: "Samenvatting", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/resume" },
                            { title: "Standaard toetsmomenten", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments" }
                        ]}
                        isDirty={false}
                        activeChapter={6}
                        {...this.props}
                    />
                </div>

                <div className="section-middle">
                    <div className="section-buttons">
                        <Link to={`/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/new`} className="btn btn-primary">
                            Standaard toetsmoment toevoegen
                        </Link>
                    </div>
                    <h2>Standaard toetsmomenten</h2>
                </div>

                <div className="row">
                    <div className="col-3 filters">
                        <Filter
                            title="Status"
                            type="list"
                            filterName="is_active"
                            filters={[
                                { value: "", name: "Alles" },
                                { value: "1", name: "Actief" },
                                { value: "0", name: "Inactief" }
                            ]}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                    </div>

                    <div className="col-9">
                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th width="50">#</th>
                                    <th>Titel</th>
                                    <th width="150">Type</th>
                                    <th width="140">Competenties</th>
                                    <th width="100">Actief</th>
                                </tr>
                            </thead>
                            <tbody>{momentRows}</tbody>
                        </table>
                    </div>
                </div>

                <div className="form-group text-center">
                    <button className="btn btn-light" type="button" onClick={this.handleSubmitPrevious}>
                        Terug naar de samenvatting
                    </button>
                    <button className="btn btn-primary" onClick={this.handleSubmit}>
                        Naar het overzicht
                    </button>
                </div>
            </div>
        );
    }
}
